import esportsLogo from "assets/images/Logo.png";
import codImage from "assets/images/call-of-duty-9130.png";

export default function AuthHeader() {
  return (
    <>
      <div className="icon">
        <img src={esportsLogo} className="logo" alt="esports logo" />
      </div>
      <img className="bg-image" src={codImage} alt="" />
    </>
  );
}
